import { IonIcon } from "@ionic/react"
import { Link } from "react-router-dom"
import { logoLinkedin } from 'ionicons/icons';

export const SocialButtons: React.FC = () => {

  return <>
  <a href="https://www.linkedin.com/in/al-cumplido-cfa-57b781113/"><IonIcon icon={logoLinkedin} size="large" /></a>
  </>
}